import { render, staticRenderFns } from "./TrangDangNhap.vue?vue&type=template&id=3bc17db7&"
import script from "./TrangDangNhap.vue?vue&type=script&lang=js&"
export * from "./TrangDangNhap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports